<template>
  <div class="big-event-card" @click="gotoLink">
    <div class="hero" v-bind:class="{ 'no-image' : !event.promo_image}">
      <div class="img-container" v-if="event.promo_image">
        <img :src="event.promo_image">
      </div>
      <div class="gradient"></div>
      <div class="overlay-info">
      </div>
      <div class="live"><i class="sl-icon-camrecorder"></i> <span class="label">live</span></div>
      <!--<div class="watchlist"><i class="sl-icon-eye"></i> <span class="views">{{ ticketCount }}</span></div>-->
      <div class="info">
        <div class="price" v-if="event.price">${{ eventPrice }}</div>
        <div class="price free" v-else>free</div>
        <div class="title">
          <h4><router-link :to="eventLink">{{ event.title }}</router-link></h4>
          <div class="when">
            {{ when }}
          </div>
        </div>
        <small>
          {{ event.artist.name }} <i class="sl-icon-location-pin"></i> {{ event.location }}
        </small>
        <p class="desc">
          {{ event.description }}
        </p>
        <div class="actions">
          <b-button variant="danger" class="remove" @click="removeFromWatchlist" v-if="amWatching">
            <font-awesome-icon icon="times" />
            remove from watchlist
          </b-button>
          <b-button class="btn-rainbow add" @click="addToWatchlist" v-if="isLoggedIn && !amWatching">
            <font-awesome-icon icon="plus"/> &nbsp; watchlist
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .big-event-card {
    margin-top: 1em;
    margin-bottom: 2em;
    background: $white;
    border-radius: 4px;
    box-shadow: 5px 5px 10px 0 rgba(0, 0, 0, 0.57);
    cursor: pointer;

    .hero {
      min-height: 210px;
      position: relative;

      &.no-image {
        .price {
          top: 65px;
        }
        .info {
          padding-top: 8.5em;
        }
      }

      .img-container {
        position: relative;
        margin-bottom: -160px;
        &:before {
          position: absolute;
          content: '';
          width: calc(100% + 0px);
          height: 320px;
          bottom: -60px;
          background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 20%, white 75%);
          z-index: 0;
          @include media-breakpoint-down(sm) {
            height: 315px;
            width: calc(100% + 1px);
            bottom: -70px;
            background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 40%, white 70%);
          }
        }
      }

      img {
        border-radius: 4px;
        width: 100%;
      }

      .gradient {
        display: none;
        border-radius: 4px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: linear-gradient(to bottom, rgba(0,0,0,0) 50%, rgba(255,255,255,1) 75%);
      }

      .watchlist {
        position: absolute;
        top: 12px;
        left: 0;
        padding: 0.5em 1em 0.3em 1em;
        border-radius: 0 4px 4px 0;
        background-color: transparentize(#777, .2);
        display: flex;
        align-items: center;

        .views {
          font-size: 0.9em;
          font-family: 'AvenirHeavy';
          line-height: 1.5;
        }

        i.sl-icon-eye {
          margin-right: 0.5em;
          margin-top: -2px;
        }
      }

      .live {
        position: absolute;
        top: 12px;
        right: 2em;
        font-size: 0.8em;
        padding: 0.5em 0.6em 0.3em 1em;
        border-radius: 4px;
        background-color: $tomato;
        box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.64);
        .label {
          display: none;
        }

        i.sl-icon-camrecorder {
          margin-right: 0.5em;
        }
        @include media-breakpoint-down(sm) {
          right: 1em;
          padding: 0.5em 0.5em 0.3em 1em;
          .label {
            display: none;
          }
        }
      }

      .price {
        position: absolute;
        font-family: 'AvenirHeavy';
        top: -15px;
        color: $white;
        background: $darkish-pink;
        width: 3.2em;
        height: 3.2em;
        border-radius: 100%;
        line-height: 3.2em;
        font-size: 1.2em;
        font-weight: bold;
        text-align: center;

        &.free {
          padding: 0.25em 1em 0.18em 1em;
          line-height: inherit;
          height: auto;
          width: auto;
          border-radius: 4px;
          top: 10px;
          @include media-breakpoint-down(xs) {
            font-size: .9em;
            top: 50px;
          }
        }
        @include media-breakpoint-down(sm) {
          font-size: .9em;
          top: 40px;
        }
      }

      .info {
        position: relative;
        left: 10px;
        right: 10px;
        bottom: 0px;
        /* height: 150px; */
        padding: 4em 2em 0 5px;
        color: $dark-gray;
        border-radius: 4px;
        @include media-breakpoint-down(xs) {
          padding-top: 6em;
        }
        @include media-breakpoint-down(sm) {
          padding: 6em 1.5em 0 5px;
        }

        .title {
          display: flex;
          align-items: center;
          font-family: 'AvenirHeavy';

          h4 {
            margin: 0;
            flex: 1;
            font-size: 1.2rem;

            a {
              color: $dark-gray;
              text-decoration: none;

              &:hover {
                text-decoration: underline;
              }
            }
          }

          .when {
            flex-basis: content;
            padding: 3px 5px 3px 5px;
            font-size: 0.8em;
            font-weight: 900;
            text-align: right;
            color: $dark-five;
            border-radius: 4px;
            background-color: $pale-gold;
          }
        }

        small {
          display: block;
          margin: 1em 0;
          @include media-breakpoint-down(sm) {
            margin: 0.3em 0 0.5em;
          }
        }

        .desc {
          margin: 0;
          font-family: 'LucidaGrande', 'AvenirBook';
          line-height: 1.65em;
          min-height: 52px;
          /* height: 3.4em; */
          overflow-y: hidden;
          @include media-breakpoint-down(md) {
            font-size: .8em;
          }
        }

        .actions {
          text-align: right;
          position: relative;
          top: 18px;

          button {
            padding: 0.5em 2em;
            @include media-breakpoint-down(sm) {
              font-size: .8em;
              svg {
                margin-right: 3px;
                position: relative;
                top: 1px;
              }
            }

            &.remove {
              background-color: $tomato;
              border-color: $tomato;
            }
          }
        }
      }

    }
  }
</style>

<script>
import moment from '@/utils/moment'
import find from 'lodash/find'

import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { mapGetters } from 'vuex'

export default {
  name: 'BigEventCard',
  components: {
    FontAwesomeIcon
  },
  props: {
    event: Object
  },
  computed: {
    when () {
      if (!this.event) return ''
      return moment(this.event.start).format('MMM Do | h:mm a')
    },
    ticketCount () {
      return this.event.ticket_count || 0
    },
    eventPrice () {
      if (!this.event.price) return '0'

      let txt = this.event.price.toFixed(2)
      const m = txt.match(/(.+)\.00$/)
      if (m) {
        txt = m[1]
      }
      return txt
    },
    amWatching () {
      if (!this.event) return false
      return find(this.currentUser.watchlist, { id: this.event.id })
    },
    eventLink () {
      if (!this.event) return null

      return {
        name: 'artist-live-stream-detail',
        params: {
          artistId: this.event.artist.id,
          liveId: this.event.id
        }
      }
    },
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapGetters('profile', ['currentUser'])
  },
  methods: {
    async addToWatchlist (ev) {
      ev.stopPropagation()
      ev.preventDefault()

      try {
        await this.$store.dispatch('live/addToWatchlist', {id: this.event.id})
        this.event.ticket_count++
        this.$store.dispatch('flash/showMessage', {message: 'Live stream added to watchlist'})
      } catch (e) {
        let errorResponse = e.response.data || {}
        this.$store.dispatch(
          'flash/showMessage',
          {message: errorResponse.detail || 'The live stream no longer exists', type: 'error'}
        )
      }
    },
    async removeFromWatchlist (ev) {
      ev.stopPropagation()
      ev.preventDefault()

      await this.$store.dispatch('live/removeFromWatchlist', {id: this.event.id})
      this.event.ticket_count--
      this.$store.dispatch('flash/showMessage', {message: 'Live stream removed from watchlist'})
    },
    gotoLink () {
      if (!this.eventLink) return
      this.$router.push(this.eventLink)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/BigEventCard.vue